<template>
  <div>
    <div class="container mx-auto flex-col flex md:justify-center">
      <div class="z-20 p-5 laptop:p-0 laptop:mt-150px">
        <MARSHeading><div v-html="$t('examples.hero')" /></MARSHeading>
        <p class="text-standard my-8 w-full md:w-2/3 laptop:w-8/12 laptop:mt-12 laptop:mb-8 leading-relaxed" v-html="$t('examples.hero-text')" />
        <!-- <div class="flex px-0">
          <img loading="lazy" class="mr-4" src="~/assets/img/ico-filter.svg">
          <Dropdown v-model="currentFilter" :elements="filters" highlight="highlight"
                    :label="$t('examples.filter-by')"></Dropdown>
        </div> -->
      </div>
    </div>

    <div class="container mx-auto mb-12 laptop:my-12 laptop:mb-150px">
      <div class="px-5 laptop:p-0 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-stretch">
        <NuxtLink
          v-for="example in examples"
          :key="example.name"
          :to="localePath(example.route)">
          <div class="md:mx-0">
            <img loading="lazy" :src="example.image" class="thumbnail w-full">
            <p class="text-standard font-bold my-2 pt-3 tracking-normal">
              {{ example.name }}
            </p>
            <p class="text-standard mb-8 tracking-normal">{{ example.description }}</p>
          </div>
        </NuxtLink>
      </div>
    </div>

    <Block1Col class="mb-8">
      <MARSTitle>{{ $t('examples.usecases-title') }}</MARSTitle>
      <p>{{ $t('platform.examples_intro') }}</p>
    </Block1Col>
    <LandingShowcaseSelector />
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'

import imgBraun from '~/assets/img/renders/Braun-KF20.webp'
import imgConsole from '~/assets/img/renders/AnamorphicConsole.webp'
import imgArmchair from '~/assets/img/renders/Armchair.webp'
import imgSpringChair from '~/assets/img/renders/SpringChair.webp'
import imgAnteastress from '~/assets/img/renders/Antea-stress.webp'
// import imgOnestring from '~/assets/img/examples/onestring.webp'

const { t } = useI18n()
const route = useRoute()
const localePath = useLocalePath()

const currentFilter = ref({
  label: t('examples.all'),
  value: 'all',
})

const menuOpen = ref(false)

const examples = computed(() => {
  const exampleList = [
    {
      name: 'Braun KF20',
      description: t('examples.example-of') + ' e-commerce',
      image: imgBraun,
      category: 'e-commerce',
      route: '/examples/braun/',
    },
    {
      name: 'Anamorphic Console',
      description: t('examples.example-of') + ' info-commerce',
      image: imgConsole,
      category: 'info commerce',
      route: '/examples/console/',
    },
    {
      name: 'Form Armchair',
      description: t('examples.example-of') + ' info-commerce',
      image: imgArmchair,
      category: 'info commerce',
      route: '/examples/form-armchair/',
    },
    {
      name: 'Spring Chair',
      description: t('examples.example-of') + ' info-commerce',
      image: imgSpringChair,
      category: 'info commerce',
      route: '/examples/spring-chair/',
    },
    {
      name: 'Antea Stress',
      description: t('examples.example-of') + ' info-commerce',
      image: imgAnteastress,
      category: 'info commerce',
      route: '/examples/antea-stress/',
    },
    // {
    //   name: 'Onestring',
    //   description: t('examples.example-of') + ' product tag',
    //   image: imgOnestring,
    //   category: 'info commerce',
    //   route: '/examples/onestring/',
    // },
  ]

  if (currentFilter.value.value === 'all') {
    return exampleList
  } else {
    return exampleList.filter(
      m => m.category.toLowerCase().trim() === currentFilter.value.value
    )
  }
})

const filters = computed(() => [
  {
    label: t('examples.all'),
    value: 'all',
  },
  {
    label: t('examples.ecommerce'),
    value: 'e-commerce',
  },
  {
    label: t('examples.infocommerce'),
    value: 'info commerce',
  },
  {
    label: t('examples.chatbot'),
    value: 'chatbot',
  },
])

watch(() => route.params.lang, () => {
  currentFilter.value.label = t('examples.' + currentFilter.value)
})
</script>

<style scoped>
</style>
